import { MailOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Card, Col, Divider, Input, Modal, Popover, Rate, Row, Select, Spin, Tabs } from "antd";
import { Fragment, useContext, useEffect, useState } from "react";
import { BiMinus, BiPlus } from "react-icons/bi";
import { BsChevronDown, BsChevronUp } from "react-icons/bs";
import { CgProfile } from "react-icons/cg";
import { IoMdClose } from "react-icons/io";
import CustomerLayout from "../../Components/CustomerLayout/CustomerLayout";
import Layout from "../../Components/Layout/Layout";
import ProductCardHorizontal from "../../Components/ProductCardHorizontal/ProductCardHorizontal";
import { AuthContext } from "../../Contexts/AuthContext";
import axios from "../../config/axios";
import moment from "../../config/moment";
import { RecommendedProducts } from "../LandingV2/LandingV2";
import filter_icon from "../ProductsByCategory/images/filter.svg";
import scan_icon from "../ProductsByCategory/images/scan_icon.svg";
import search_icon from "../ProductsByCategory/images/search.svg";
import styles from "./CustomerLists.module.scss";
import all_black from "./images/all_black.svg";
import buy_active from "./images/buy_active.svg";
import buy_inactive from "./images/buy_inactive.svg";
import liked_active from "./images/liked_active.svg";
import liked_inactive from "./images/liked_inactive.svg";
import shopping_active from "./images/shopping_active.svg";
import shopping_inactive from "./images/shopping_inactive.svg";

const CustomerLists = () => {
    const [activeKey, setActiveKey] = useState("1");
    return (
        <>
            {window.innerWidth < 991 ? (
                <Layout>
                    <div className="container">
                        <div className="custom_coupon_tab" style={{ marginInline: 20 }}>
                            <Tabs
                                defaultActiveKey="1"
                                tabPosition="top"
                                animated={{
                                    inkBar: true,
                                    tabPane: true,
                                }}
                                onChange={(activeKey) => {
                                    setActiveKey(activeKey);
                                }}
                            >
                                <Tabs.TabPane
                                    tab={
                                        <div className={styles.tab_header}>
                                            <img src={activeKey === "1" ? buy_active : buy_inactive} alt="buy_again" />
                                            <span>Buy Again</span>
                                        </div>
                                    }
                                    key="1"
                                >
                                    <BuyAgain />
                                </Tabs.TabPane>
                                <Tabs.TabPane
                                    tab={
                                        <div className={styles.tab_header}>
                                            <img src={activeKey === "2" ? shopping_active : shopping_inactive} alt="shopping_list" />
                                            <span>Shopping List</span>
                                        </div>
                                    }
                                    key="2"
                                >
                                    <ShoppingList />
                                </Tabs.TabPane>
                                <Tabs.TabPane
                                    tab={
                                        <div className={styles.tab_header}>
                                            <img src={activeKey === "3" ? liked_active : liked_inactive} alt="liked_items" />
                                            <span>Liked Items</span>
                                        </div>
                                    }
                                    key="3"
                                >
                                    <LikedItems />
                                </Tabs.TabPane>
                            </Tabs>
                        </div>
                    </div>
                </Layout>
            ) : (
                <CustomerLayout breadcrumb={[]}>
                    <div className="container">
                        <div className="custom_coupon_tab" style={{ marginInline: 20 }}>
                            <Tabs
                                defaultActiveKey="1"
                                tabPosition="top"
                                animated={{
                                    inkBar: true,
                                    tabPane: true,
                                }}
                                onChange={(activeKey) => {
                                    setActiveKey(activeKey);
                                }}
                            >
                                <Tabs.TabPane
                                    tab={
                                        <div className={styles.tab_header}>
                                            <img src={activeKey === "1" ? buy_active : buy_inactive} alt="buy_again" />
                                            <span>Buy Again</span>
                                        </div>
                                    }
                                    key="1"
                                >
                                    <BuyAgain />
                                </Tabs.TabPane>
                                <Tabs.TabPane
                                    tab={
                                        <div className={styles.tab_header}>
                                            <img src={activeKey === "2" ? shopping_active : shopping_inactive} alt="shopping_list" />
                                            <span>Shopping List</span>
                                        </div>
                                    }
                                    key="2"
                                >
                                    <ShoppingList />
                                </Tabs.TabPane>
                                <Tabs.TabPane
                                    tab={
                                        <div className={styles.tab_header}>
                                            <img src={activeKey === "3" ? liked_active : liked_inactive} alt="liked_items" />
                                            <span>Liked Items</span>
                                        </div>
                                    }
                                    key="3"
                                >
                                    <LikedItems />
                                </Tabs.TabPane>
                            </Tabs>
                        </div>
                    </div>
                </CustomerLayout>
            )}
        </>
    );
};

export default CustomerLists;

// sub components
const BuyAgain = () => {
    const [activeTab, setActiveTab] = useState("fp");
    const [fpItems, setFpItems] = useState([]);
    const [rbItems, setRbItems] = useState([]);
    const [fpLoading, setFpLoading] = useState(true);
    const [rbLoading, setRbLoading] = useState(true);
    const [showPLActiveItemID, setShowPLActiveItemID] = useState(null);

    // handle active show product list item
    const handleShowPLActiveItem = (id) => {
        if (showPLActiveItemID === id) {
            setShowPLActiveItemID(null);
        } else {
            setShowPLActiveItemID(id);
        }
    };

    // get frequently purchased items
    useEffect(() => {
        (async () => {
            try {
                const response = await axios.get("/orders/filter/users", {
                    withCredentials: true,
                });
                // get order items array and merge them into one array
                const orderItems = response.data.map((order) => order.order_items).flat();
                // insert timestamp from order into order item
                const orderItemsWithTimestamp = orderItems.map((orderItem) => {
                    const timestamp = response.data.find((order) => order.id === orderItem.order).timestamp;
                    return { ...orderItem, timestamp };
                });
                setFpItems(orderItemsWithTimestamp);
            } catch (e) {
                console.log(e);
            } finally {
                setFpLoading(false);
            }
        })();
    }, []);

    // get recently bought items
    useEffect(() => {
        (async () => {
            try {
                const response = await axios.get("/orders/filter/users", {
                    withCredentials: true,
                });
                setRbItems(response.data);
            } catch (e) {
                console.log(e);
            } finally {
                setRbLoading(false);
            }
        })();
    }, []);

    const popoverData = [
        {
            title: "View Order",
            image: "https://desi-fresh.b-cdn.net/components_static/Account/eye.svg",
        },
        {
            title: "Tracking",
            image: "https://desi-fresh.b-cdn.net/components_static/Account/tracking.svg",
        },
        {
            title: "Share",
            image: "https://desi-fresh.b-cdn.net/components_static/Account/share.svg",
        },
    ];

    const orderPopover = (
        <div className={styles.order_popover}>
            {popoverData.map((item, index) => (
                <div className={styles.order_popover_item} key={index}>
                    <img src={item.image} alt={item.title} />
                    <div>{item.title}</div>
                </div>
            ))}
        </div>
    );

    const handleBuyAgain = (id) => {
        console.log(id);
    };

    return (
        <>
            <div className={styles.ba_top}>
                <span
                    className={activeTab === "fp" ? `${styles.ba_top_txt} ${styles.ba_top_txt_active}` : styles.ba_top_txt}
                    onClick={() => setActiveTab("fp")}
                >
                    Frequently Purchased
                </span>
                <span
                    className={activeTab === "rb" ? `${styles.ba_top_txt} ${styles.ba_top_txt_active}` : styles.ba_top_txt}
                    onClick={() => setActiveTab("rb")}
                >
                    Recently Bought
                </span>
            </div>

            <>
                {activeTab === "fp" && (
                    <>
                        {fpLoading ? (
                            <div className={styles.loading}>
                                <Spin />
                            </div>
                        ) : (
                            <>
                                {fpItems.length > 0 ? (
                                    <Row style={{ marginTop: 15 }} gutter={[20, 20]}>
                                        {fpItems.map((item, index) => (
                                            <Col xs={24} lg={12} style={{ marginBottom: 15 }} key={index}>
                                                <div className={styles.ba_pc_top}>
                                                    <p> Order ID: #{item.order} </p>
                                                    <p> Date: {moment(item.timestamp).format("DD.MM.YYYY")} </p>
                                                </div>
                                                <ProductCardHorizontal product={item} singleVariant={true} />
                                            </Col>
                                        ))}
                                    </Row>
                                ) : (
                                    <div className={styles.empty_wishlist}>
                                        <h2>No Orders Found</h2>
                                        <p>You have not made any orders yet.</p>
                                    </div>
                                )}
                            </>
                        )}
                    </>
                )}
                {activeTab === "rb" && (
                    <div className={styles.ba_bottom_rb}>
                        {rbLoading ? (
                            <div className={styles.loading}>
                                <Spin />
                            </div>
                        ) : (
                            <>
                                {rbItems.length > 0 ? (
                                    <Row gutter={[20, 20]}>
                                        {rbItems.map((item, index) => (
                                            <Col xs={24} lg={12} style={{ marginBottom: 15 }} key={index}>
                                                <Card
                                                    bordered={false}
                                                    bodyStyle={{ padding: 10 }}
                                                    style={{
                                                        boxShadow: "0px 2px 5px 1px rgba(0, 0, 0, 0.05)",
                                                    }}
                                                >
                                                    <Row>
                                                        <Col span={11}>
                                                            <Fragment>
                                                                <strong> Order Id: </strong>
                                                                <strong> #{item.id} </strong>
                                                            </Fragment>
                                                            <br />
                                                            <Fragment>
                                                                <strong> Date: </strong>
                                                                <span> {moment(item.timestamp).format("DD.MM.YYYY")} </span>
                                                            </Fragment>
                                                        </Col>
                                                        <Col span={11}>
                                                            <div
                                                                className={styles.ba_pr_det}
                                                                onClick={() => {
                                                                    handleShowPLActiveItem(item.id);
                                                                }}
                                                            >
                                                                <span>Product Details</span>
                                                                {showPLActiveItemID === item.id ? <BsChevronUp /> : <BsChevronDown />}
                                                            </div>
                                                            <div>
                                                                <Button
                                                                    type="primary"
                                                                    onClick={() => {
                                                                        handleBuyAgain(item.id);
                                                                    }}
                                                                >
                                                                    Buy Again
                                                                </Button>
                                                            </div>
                                                        </Col>
                                                        <Col span={2}>
                                                            <Popover
                                                                content={orderPopover}
                                                                placement="bottomRight"
                                                                trigger="click"
                                                                overlayClassName="custom_order_popover"
                                                            >
                                                                <img
                                                                    className={styles.three_dot}
                                                                    src="https://desi-fresh.b-cdn.net/components_static/Account/three_dot_horiz.svg"
                                                                    alt="dot"
                                                                />
                                                            </Popover>
                                                        </Col>
                                                        <Col span={24}>
                                                            <div className={styles.order_items}>
                                                                {item.order_items.slice(0, 6).map((item, index) => (
                                                                    <img src={item.image} key={index} alt={index} />
                                                                ))}
                                                            </div>
                                                        </Col>
                                                        <Col span={12}>
                                                            <Fragment>
                                                                <div>
                                                                    <strong>Rating</strong>
                                                                </div>
                                                                <Rate />
                                                            </Fragment>
                                                        </Col>
                                                        <Col span={12}>
                                                            <div className={styles.order_total}>Price : {item.total}€</div>
                                                        </Col>
                                                    </Row>
                                                </Card>
                                                {showPLActiveItemID === item.id && (
                                                    <div
                                                        style={{
                                                            marginTop: 20,
                                                        }}
                                                    >
                                                        {item.order_items.map((item, index) => (
                                                            <div
                                                                style={{
                                                                    marginBottom: 15,
                                                                }}
                                                                key={index}
                                                            >
                                                                <ProductCardHorizontal product={item} singleVariant={true} />
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            </Col>
                                        ))}
                                    </Row>
                                ) : (
                                    <div className={styles.empty_wishlist}>
                                        <h2>No Orders Found</h2>
                                        <p>You have not made any orders yet.</p>
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                )}
            </>
        </>
    );
};

const ShoppingList = () => {
    const [loading, setLoading] = useState(true);
    const [list, setList] = useState([]);
    const [showPLActiveItemID, setShowPLActiveItemID] = useState(null);
    const [createListModalOpen, setCreateListModalOpen] = useState(false);
    const [popoverVisible, setPopoverVisible] = useState(false);
    const [popoverVisibleItemID, setPopoverVisibleItemID] = useState(null);
    const [shareWithModalOpen, setShareWithModalOpen] = useState(false);

    // handle active show product list item
    const handleShowPLActiveItem = (id) => {
        if (showPLActiveItemID === id) {
            setShowPLActiveItemID(null);
        } else {
            setShowPLActiveItemID(id);
        }
    };

    useEffect(() => {
        setTimeout(() => {
            setLoading(false);
            setList([
                {
                    id: 1,
                    name: "Birthday Party",
                    items: [
                        {
                            id: 1,
                            image: "https://picsum.photos/200/300",
                            name: "Product Name",
                            price: 17.36,
                            quantity: 2,
                        },
                        {
                            id: 2,
                            image: "https://picsum.photos/200/300",
                            name: "Product Name",
                            price: 17.36,
                            quantity: 2,
                        },
                    ],
                    total_price: 17.36,
                },
                {
                    id: 2,
                    name: "Ramadan List",
                    items: [
                        {
                            id: 10,
                            image: "https://picsum.photos/200/300",
                            name: "Product Name",
                            price: 17.36,
                            quantity: 2,
                        },
                        {
                            id: 20,
                            image: "https://picsum.photos/200/300",
                            name: "Product Name",
                            price: 17.36,
                            quantity: 2,
                        },
                    ],
                    total_price: 17.36,
                },
            ]);
        }, 1000);
    }, []);

    const showConfirm = () => {
        Modal.confirm({
            title: "Are you sure?",
            content: "You are about to delete this list",
            icon: null,
            okText: "Yes",
            cancelText: "No",
            okButtonProps: {
                style: {
                    backgroundColor: "#ff3939",
                    color: "#fff",
                    border: "none",
                    width: "9rem",
                    height: "4rem",
                },
            },
            cancelButtonProps: {
                style: {
                    backgroundColor: "#a6a6aa",
                    color: "#000",
                    border: "none",
                    width: "9rem",
                    height: "4rem",
                },
            },
            onOk() {
                console.log("OK");
            },
            onCancel() {
                console.log("Cancel");
            },
            centered: true,
            bodyStyle: {
                textAlign: "center",
            },
            className: "custom_confirm_modal",
        });
    };

    const popoverData = [
        {
            title: "Share With",
            image: "https://desi-fresh.b-cdn.net/components_static/Account/share.svg",
            onClick: () => {
                setPopoverVisible(false);
                setShareWithModalOpen(true);
            },
        },
        {
            title: "View/Edit",
            image: "https://desi-fresh.b-cdn.net/components_static/Account/eye.svg",
            onClick: () => {
                setPopoverVisible(false);
                return;
            },
        },
        {
            title: "Delete",
            image: "https://desi-fresh.b-cdn.net/components_static/delete.svg",
            onClick: () => {
                showConfirm();
                setPopoverVisible(false);
            },
        },
    ];

    const orderPopover = (
        <div className={styles.order_popover}>
            {popoverData.map((item, index) => (
                <div className={styles.order_popover_item} key={index} onClick={item.onClick}>
                    <img src={item.image} alt={item.title} />
                    <div>{item.title}</div>
                </div>
            ))}
        </div>
    );

    const increaseQty = (id) => {
        // loop through product list and loop through items of each product and increase quantity of item that has same id
        const newProductList = list.map((item) => {
            item.items = item.items.map((item) => {
                if (item.id === id) {
                    item.quantity = item.quantity + 1;
                }
                return item;
            });
            return item;
        });
        setList(newProductList);
    };

    const decreaseQty = (id) => {
        // loop through product list and loop through items of each product and decrease quantity of item that has same id
        const newProductList = list.map((item) => {
            item.items = item.items.map((item) => {
                if (item.id === id) {
                    item.quantity = item.quantity - 1;
                    if (item.quantity === 0) {
                        item.quantity = 1;
                    }
                }
                return item;
            });
            return item;
        });
        setList(newProductList);
    };

    return (
        <div className={styles.sl_wrap}>
            {loading ? (
                <>
                    <div className={styles.loading}>
                        <Spin />
                    </div>
                </>
            ) : (
                <>
                    {list.length > 0 ? (
                        <Row gutter={[20, 20]}>
                            {list.map((item, index) => (
                                <Col xs={24} lg={12} className={styles.sl_item} key={index}>
                                    <div className={styles.sl_item_header}> {item.name} </div>
                                    <Card
                                        bordered={false}
                                        bodyStyle={{ padding: 10 }}
                                        style={{
                                            boxShadow: "0px 2px 5px 1px rgba(0, 0, 0, 0.05)",
                                        }}
                                    >
                                        <Row>
                                            <Col span={11}>
                                                <strong> {item.name} </strong>
                                            </Col>
                                            <Col span={11}>
                                                <div
                                                    className={styles.ba_pr_det}
                                                    onClick={() => {
                                                        handleShowPLActiveItem(item.id);
                                                    }}
                                                >
                                                    <b>Product Details</b>
                                                    {showPLActiveItemID === item.id ? <BsChevronUp /> : <BsChevronDown />}
                                                </div>
                                            </Col>
                                            <Col span={2}>
                                                <Popover
                                                    content={orderPopover}
                                                    placement="bottomRight"
                                                    trigger="click"
                                                    overlayClassName="custom_order_popover"
                                                    open={popoverVisible && popoverVisibleItemID === item.id}
                                                    onOpenChange={(visible) => {
                                                        setPopoverVisible(visible);
                                                    }}
                                                >
                                                    <img
                                                        className={styles.three_dot}
                                                        onClick={() => {
                                                            setPopoverVisibleItemID(item.id);
                                                        }}
                                                        src="https://desi-fresh.b-cdn.net/components_static/Account/three_dot_horiz.svg"
                                                        alt="dot"
                                                    />
                                                </Popover>
                                            </Col>
                                            <Col span={24}>
                                                <div className={styles.order_items} style={{ marginBottom: 10 }}>
                                                    {item.items.slice(0, 6).map((item, index) => (
                                                        <img src={item.image} key={index} alt={index} />
                                                    ))}
                                                </div>
                                            </Col>
                                            <Col span={12}>
                                                <div
                                                    className={styles.order_total}
                                                    style={{
                                                        justifyContent: "flex-start",
                                                        marginTop: 5,
                                                    }}
                                                >
                                                    Price : {item.total_price}€
                                                </div>
                                            </Col>
                                            <Col span={12}>
                                                <Button style={{ }} block>
                                                    {" "}
                                                    Checkout{" "}
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Card>
                                    {showPLActiveItemID === item.id && (
                                        <div style={{ marginTop: 10 }}>
                                            {item.items.map((item, index) => (
                                                <div style={{ marginBottom: 15 }} key={index}>
                                                    <Card
                                                        bordered={false}
                                                        bodyStyle={{
                                                            padding: 10,
                                                        }}
                                                        style={{
                                                            boxShadow: "0px 2px 5px 1px rgba(0, 0, 0, 0.05)",
                                                        }}
                                                    >
                                                        <Row gutter={[10, 0]}>
                                                            <Col span={6}>
                                                                <img className={styles.list_item_img} src={item.image} alt={index} />
                                                            </Col>
                                                            <Col span={10}>
                                                                <div className={styles.list_item_name}> {item.name} </div>
                                                                <div> {item.price}€ Unit Price</div>
                                                                <div> 36€ Unit Price</div>
                                                            </Col>
                                                            <Col span={8}>
                                                                <div
                                                                    style={{
                                                                        display: "flex",
                                                                        width: "100%",
                                                                        marginTop: 10,
                                                                    }}
                                                                >
                                                                    <div className={styles.productCard_actions_middle}>
                                                                        <BiMinus
                                                                            size={20}
                                                                            onClick={() => {
                                                                                decreaseQty(item.id);
                                                                            }}
                                                                        />
                                                                        <div className={styles.stock_amount}>{item.quantity}</div>
                                                                        <BiPlus
                                                                            size={20}
                                                                            onClick={() => {
                                                                                increaseQty(item.id);
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </Card>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </Col>
                            ))}
                        </Row>
                    ) : (
                        <div className={styles.empty_wishlist}>
                            <h2>No Shopping List Found</h2>
                            <p>You have not made any shopping list yet.</p>
                        </div>
                    )}
                    <div className={styles.new_list_btn}>
                        <Button
                            type="primary"
                            icon={<PlusOutlined />}
                            onClick={() => {
                                setCreateListModalOpen(true);
                            }}
                        >
                            Create a new List
                        </Button>
                    </div>
                </>
            )}
            {createListModalOpen && (
                <Modal
                    closable={false}
                    className="share_with_modal"
                    title={
                        <div className={styles.share_with_modal_header}>
                            <p>Name your new list</p>
                            <IoMdClose
                                size={20}
                                color="white"
                                onClick={() => {
                                    setCreateListModalOpen(false);
                                }}
                            />
                        </div>
                    }
                    visible={true}
                    onCancel={() => {
                        setCreateListModalOpen(false);
                    }}
                    footer={null}
                    centered
                    bodyStyle={{ padding: 15 }}
                >
                    <Row>
                        <Col span={24}>
                            <Input size="middle" placeholder="List Name" />
                        </Col>
                        <Col span={24} style={{ marginTop: 20 }}>
                            <Input size="middle" value="shamim@gmail.com" readOnly />
                        </Col>
                        <Col
                            span={24}
                            style={{
                                marginTop: 20,
                                display: "flex",
                                justifyContent: "center",
                            }}
                        >
                            <Button type="primary">Add List Member</Button>
                        </Col>
                    </Row>
                    <Divider
                        style={{
                            margin: "15px 0",
                        }}
                    />
                    <Row>
                        <Col span={16}>
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "flex-start",
                                    gap: 5,
                                    height: "100%",
                                }}
                            >
                                <CgProfile size={20} />
                                <span> Najmul Hasan </span>
                            </div>
                        </Col>
                        <Col span={8}>
                            <Select defaultValue="view" style={{ width: "100%" }}>
                                <Select.Option value="view">Can View</Select.Option>
                                <Select.Option value="edit">Can Edit</Select.Option>
                            </Select>
                        </Col>
                        <Col
                            span={24}
                            style={{
                                marginTop: 20,
                                display: "flex",
                                justifyContent: "center",
                            }}
                        >
                            <Button type="primary">Save List</Button>
                        </Col>
                    </Row>
                </Modal>
            )}
            {shareWithModalOpen && (
                <Modal
                    closable={false}
                    className="share_with_modal"
                    title={
                        <div className={styles.share_with_modal_header}>
                            <p>Share With</p>
                            <IoMdClose
                                size={20}
                                color="white"
                                onClick={() => {
                                    setShareWithModalOpen(false);
                                }}
                            />
                        </div>
                    }
                    open={true}
                    onCancel={() => {
                        setShareWithModalOpen(false);
                    }}
                    footer={null}
                    centered
                    bodyStyle={{ padding: 15 }}
                >
                    <Row gutter={[15, 0]}>
                        <Col span={16}>
                            <Input size="middle" placeholder="johndoe@gmail.com" prefix={<MailOutlined />} />
                        </Col>
                        <Col span={8}>
                            <Button type="primary" block>
                                Share
                            </Button>
                        </Col>
                    </Row>
                    <Divider
                        style={{
                            margin: "15px 0",
                        }}
                    />
                    <Row>
                        <Col span={16}>
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "flex-start",
                                    gap: 5,
                                    height: "100%",
                                }}
                            >
                                <CgProfile size={20} />
                                <span> Najmul Hasan </span>
                            </div>
                        </Col>
                        <Col span={8}>
                            <Select defaultValue="view" style={{ width: "100%" }}>
                                <Select.Option value="view">Can View</Select.Option>
                                <Select.Option value="edit">Can Edit</Select.Option>
                            </Select>
                        </Col>
                    </Row>
                </Modal>
            )}
        </div>
    );
};

const LikedItems = () => {
    const { user } = useContext(AuthContext);
    const [subSubcategories, setSubSubcategories] = useState([]);
    const [activeSubSubcategory, setActiveSubSubcategory] = useState("all");
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filteredList, setFilteredList] = useState([]);
    const [searchText, setSearchText] = useState("");

    useEffect(() => {
        (async () => {
            const response = await axios.get("/public/sub-subcategories");
            setSubSubcategories(response.data);
        })();
    }, []);

    useEffect(() => {
        (async () => {
            const ids = user.wishlist.map((item) => item).join(",");
            const response = await axios.get(`/public/products/list/id?ids=${ids}`);
            setProducts(response.data);
            setLoading(false);
        })();
    }, [user.wishlist]);

    // filter items
    useEffect(() => {
        if (searchText.length === 0) {
            setFilteredList(products);
            return;
        }
        const filtered = products.filter((product) => {
            return product.title.toLowerCase().includes(searchText.toLowerCase());
        });
        setFilteredList(filtered);
    }, [searchText, products]);

    // filter by sub subcategory
    useEffect(() => {
        if (activeSubSubcategory === "all") {
            setFilteredList(products);
            return;
        }
        const filtered = products?.filter((product) => {
            return product.sub_subcategory === activeSubSubcategory;
        });
        setFilteredList(filtered);
    }, [activeSubSubcategory, products]);

    if (user.wishlist.length === 0) {
        return (
            <div className={styles.empty_wishlist}>
                <h2>Liked Items is empty</h2>
                <p>You have no items in your liked items. To add, click on the heart icon on the product page.</p>
            </div>
        );
    }

    return (
        <>
            <div className={styles.sub_subcategories}>
                <div
                    className={
                        activeSubSubcategory === "all"
                            ? `${styles.subsubcategory_item} ${styles.subsubcategory_item_active}`
                            : styles.subsubcategory_item
                    }
                    onClick={() => setActiveSubSubcategory("all")}
                >
                    <div className={styles.subsubcategory_image}>
                        <img style={{ height: 17 }} src={all_black} alt={"all_green"} />
                    </div>
                    <div className={styles.subsubcategory_name}>
                        <span>All</span>
                    </div>
                </div>
                {subSubcategories.map((subSubcategory, index) => (
                    <div
                        className={
                            activeSubSubcategory === subSubcategory.id
                                ? `${styles.subsubcategory_item} ${styles.subsubcategory_item_active}`
                                : styles.subsubcategory_item
                        }
                        onClick={() => setActiveSubSubcategory(subSubcategory.id)}
                        key={index}
                    >
                        <div className={styles.subsubcategory_image}>
                            <img src={subSubcategory.image} alt={subSubcategory.name} />
                        </div>
                        <div className={styles.subsubcategory_name}>
                            <span>{subSubcategory.name}</span>
                        </div>
                    </div>
                ))}
            </div>

            <div className={styles.mobile_title_filter}>
                <Input
                    placeholder="Search for liked Items"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    prefix={<img src={search_icon} alt="search_icon" />}
                    suffix={
                        <>
                            <img src={scan_icon} alt="scan_icon" />
                            <img src={filter_icon} alt="filter_icon" className={styles.filter_icon} />
                        </>
                    }
                />
            </div>

            <div className={styles.all_items_top}>
                <div>All Items</div>
                <div> {user.wishlist.length} Liked</div>
            </div>

            {loading ? (
                <div className={styles.loading}>
                    <Spin />
                </div>
            ) : (
                <>
                    {filteredList.length === 0 ? (
                        <div className={styles.empty_wishlist}>
                            <h2>No items found</h2>
                            <p>We couldn't find any items matching your search or filter. Try searching for something else.</p>
                        </div>
                    ) : (
                        <Row gutter={[20, 20]}>
                            {filteredList.map((product, index) => (
                                <Col xs={24} lg={12} style={{ marginBottom: 15 }} key={index}>
                                    <ProductCardHorizontal product={product} />
                                </Col>
                            ))}
                        </Row>
                    )}
                </>
            )}
            <Divider />
            <div style={{ marginInline: -15 }}>
                <RecommendedProducts />
            </div>
        </>
    );
};
